const search = {
  namespaced: true,
  state: {
    searchArr: [],
    locationAgentCode: '',
    isProtect: false, // 是否是受保护文件
    warningLevel: 0, // 受保护等级
    warningText: "", // 受保护文件提示语
  },
  mutations: {
    setSearchArr: (state, key) => {
      state.searchArr = key
    },
    setLocationAgentCode: (state, key) => {
      state.locationAgentCode = key
    },
    setIsProtect: (state, key) => {
      state.isProtect = key
    },
    setWarningLevel: (state, key) => {
      state.warningLevel = key
    },
    setWarningText: (state, key) => {
      state.warningText = key
    }
  },
  actions: {
    updateSearchArr: ({
      commit
    }, key) => {
      commit('setSearchArr', key)
    }
  }
}

export default search